"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCardMaximumAmount = exports.CARD_MAXIMUM_AMOUNT_DEFAULT = void 0;
const form_1 = require("../constants/form");
exports.CARD_MAXIMUM_AMOUNT_DEFAULT = 5_000_00;
const getCardMaximumAmount = (organizationCardMaximumAmount) => Math.min(form_1.MAX_PAYMENT_AMOUNT_WITHOUT_TIP, organizationCardMaximumAmount ?? exports.CARD_MAXIMUM_AMOUNT_DEFAULT);
exports.getCardMaximumAmount = getCardMaximumAmount;
